'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Slider = styled.div.withConfig({
  displayName: "Ribbon__Slider"
})(["position:relative;height:", ";border-radius:2px;box-shadow:0 0 2px #808080 inset;background-image:linear-gradient( to right,#ff0000 0%,#ff9900 10%,#cdff00 20%,#35ff00 30%,#00ff66 40%,#00fffd 50%,#0066ff 60%,#3200ff 70%,#cd00ff 80%,#ff0099 90%,#ff0000 100% );"], ({
  includeAlpha
}) => includeAlpha ? `14px` : `30px`);
const SliderIndicator = styled.span.withConfig({
  displayName: "Ribbon__SliderIndicator"
})(({
  theme,
  $left
}) => ({
  position: 'absolute',
  top: '2px',
  bottom: '2px',
  width: '6px',
  border: `${theme.borderWidth['100']} solid #888888`,
  padding: `${theme.space['25']} ${theme.space['0']}`,
  marginLeft: `-3px`,
  backgroundColor: '#eeeeee',
  borderRadius: theme.borderRadius['100'],
  left: $left
}));
const SliderHandler = styled.div.withConfig({
  displayName: "Ribbon__SliderHandler"
})(["position:absolute;width:104%;height:100%;left:-2%;cursor:pointer;"]);
export default class Ribbon extends Component {
  constructor(...args) {
    super(...args);
    this.onMouseDown = evt => {
      evt.preventDefault();
      const x = evt.clientX;
      const y = evt.clientY;
      this.pointMoveTo({
        x,
        y
      });
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.onDragEnd);
    };
    this.onDrag = evt => {
      const x = evt.clientX;
      const y = evt.clientY;
      this.pointMoveTo({
        x,
        y
      });
    };
    this.onDragEnd = evt => {
      const x = evt.clientX;
      const y = evt.clientY;
      this.pointMoveTo({
        x,
        y
      });
      this.removeMouseListeners();
    };
    this.pointMoveTo = coords => {
      const rect = this.measureBounds();
      const width = rect.width;
      let left = coords.x - rect.left;
      left = Math.max(0, left);
      left = Math.min(left, width);
      const huePercent = left / width;
      const hue = Math.floor(huePercent * 360);
      this.props.onChange({
        hue
      });
    };
  }
  componentWillUnmount() {
    this.removeMouseListeners();
  }
  removeMouseListeners() {
    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('mouseup', this.onDragEnd);
  }
  measureBounds() {
    return this.slider && this.slider.getBoundingClientRect();
  }
  render() {
    const {
      hue,
      includeAlpha
    } = this.props;
    const percent = hue / 360 * 100;

    // @bend-expect trellis-tokenized
    return /*#__PURE__*/_jsxs(Slider, {
      ref: el => this.slider = el,
      "data-test-id": "ribbon-slider",
      includeAlpha: includeAlpha,
      percent: percent,
      children: [/*#__PURE__*/_jsx(SliderIndicator, {
        "data-test-id": "ribbon-slider-indicator",
        $left: `${percent}%`
      }), /*#__PURE__*/_jsx(SliderHandler, {
        "data-test-id": "ribbon-handler",
        onMouseDown: this.onMouseDown
      })]
    });
  }
}
Ribbon.propTypes = {
  hue: PropTypes.number,
  onChange: PropTypes.func,
  includeAlpha: PropTypes.bool
};